import { useEffect } from 'react';

import { useMapContextRedistributor } from 'app/contexts/MapContextRedistributor/mapContextRedistributorProvider';
import { useMapVariant } from 'app/contexts/mapVariantProvider';

import { MapVariety } from 'app/models';

import { reportAnalyticsAction } from 'utils/helpers/analyticsReporter';

export const useReportOpenMap = () => {
  const variety = useMapVariety();
  useEffect(() => {
    reportAnalyticsAction('openMap', { variety });
  }, [variety]);
};

const useMapVariety = (): MapVariety => {
  const { isEmbedded } = useMapContextRedistributor();
  const { isPreviewMapOpen, mapCompareState } = useMapVariant();

  if (isEmbedded) return 'Embedded';
  if (isPreviewMapOpen) return 'Preview';
  if (mapCompareState) return 'Comparison';
  return 'Datatray';
};
